import { IconSubtask } from '@tabler/icons-react'

export const PERMISSION_SETS_TASKS = {
  id: 'Tasks',
  description:
    'Grant access to view, create, edit, complete, and delete tasks.',
  icon: IconSubtask,
  sections: [
    {
      title: 'for themselves',
      permissions: [
        {
          type: 'checkbox',
          label: 'Manage tasks for themselves',
          children: [
            {
              type: 'checkbox',
              label: 'View, create, edit, and delete tasks',
            },
            {
              type: 'checkbox',
              label: 'Mark tasks complete',
            },
            {
              type: 'checkbox',
              label: `View others' tasks`,
            },
          ],
        },
      ],
    },
    {
      title: 'for others',
      permissions: [
        {
          type: 'checkbox',
          label: 'Manage tasks for others',
          children: [
            {
              type: 'checkbox',
              label: 'Create, edit, and delete tasks',
            },
            {
              type: 'checkbox',
              label: 'Mark tasks complete',
            },
          ],
        },
      ],
    },
  ],
}
